<template>
  <div class="container mt-4 border">
    <div class="d-flex align-items-center justify-content-between">

      <div style="font-size: 18px; font-weight: bold;">Users</div>
      <!-- Toolbar -->
      <div class="d-flex align-items-center gap-2 mt-2 flex-nowrap" style="overflow:auto; white-space: nowrap;">
        <input
          v-model.trim="q"
          @keyup.enter="reload"
          type="search"
          class="form-control"
          placeholder="ค้นหาชื่อแผน (กด Enter)"
          style="max-width: 260px; min-width: 200px;"
        />
        <select v-model.number="size" class="form-select" style="width: 120px;">
          <option :value="10">10 / หน้า</option>
          <option :value="20">20 / หน้า</option>
          <option :value="50">50 / หน้า</option>
        </select>
        <button class="btn btn-outline-primary" :disabled="loading" @click="reload">
          {{ loading ? "กำลังโหลด..." : "รีเฟรช" }}
        </button>
      </div>
    </div>
    <table class="table table-bordered table-striped mt-3 rounded-5">
      <thead class="mt-2 border rounded">
        <tr class="bg-white">
          <th>No</th>
          <th>Username</th>
          <th>Name</th>
          <th>Role</th>
          <th>Email</th>
          <th>Create time</th>
          <th>Edit</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="loading">
          <td colspan="7" class="text-center text-muted py-4">กำลังโหลดข้อมูล...</td>
        </tr>
        <tr v-else-if="total === 0">
          <td colspan="7" class="text-center text-muted py-4">ไม่พบข้อมูล</td>
        </tr>
        <tr v-else v-for="(person, index) in users" :key="index">
          <td class="text-center">{{ index+1 }}</td>
          <td>{{ person.username }}</td>
          <td>{{ person.firstName}} {{ person.localStorageName}}</td>
          <td>{{ person.role }}</td>
          <td>{{ person.email }}</td>
          <td>{{ person.createdAt }}</td>
          <td class="text-center">
            <button type="button" class="btn text-white py-1 px-2 rounded-4" data-bs-toggle="modal" @click="user_data_current = person"
              data-bs-target="#editUserModal" style="background-color: rgb(47, 144, 220); font-size: 14px;">
              <font-awesome-icon :icon="['fas', 'pen']" /> Edit
            </button> 
            <button @click="deleteUser(person.id)" type="button" class="btn btn-danger text-white py-0 ms-1 py-1 px-2 rounded-4" style="font-size: 14px;">Delete</button>
            </td>
        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <div class="d-flex justify-content-between align-items-center mt-2 mb-4">
        <div class="text-muted">ทั้งหมด: {{ total }} รายการ</div>
        <div class="btn-group">
          <button class="btn btn-outline-secondary" :disabled="page <= 1 || loading" @click="prevPage">ก่อนหน้า</button>
          <span class="btn btn-outline-secondary disabled">หน้า {{ page }}</span>
          <button class="btn btn-outline-secondary" :disabled="disableNext || loading" @click="nextPage">ถัดไป</button>
        </div>
      </div>
    <!-- Edit User Modal -->

    <div class="modal fade" id="editUserModal" tabindex="-1" aria-labelledby="editUserModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content rounded-4">
          <div class="modal-header">
            <h5 class="modal-title" id="editUserModalLabel"><font-awesome-icon :icon="['fas', 'pen']" /> Edit User</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label"><i class="bi bi-envelope"></i> Username</label>
                  <input type="email" class="form-control" placeholder="Username" v-model="user_data_current.username">
                </div>

                <div class="mb-3">
                  <label class="form-label"><i class="bi bi-envelope"></i> Email</label>
                  <input type="email" class="form-control" placeholder="Email" v-model="user_data_current.email">
                </div>

                <div class="mb-3">
                  <label class="form-label"><i class="bi bi-card-list"></i> First Name</label>
                  <input type="text" class="form-control" placeholder="First Name" v-model="user_data_current.firstName">
                </div>


                <div class="mb-3">
                  <label class="form-label"><i class="bi bi-card-list"></i> Last Name</label>
                  <input type="text" class="form-control" placeholder="Last Name" v-model="user_data_current.lastName">
                </div>

                <div class="mb-3">
                  <label class="form-label"><i class="bi bi-card-list"></i> Set New Password</label>
                  <input type="text" class="form-control" placeholder="New Password" v-model="user_data_current.password">
                </div>

                <div class="mb-3">
                  <label class="form-label"><i class="bi bi-person-badge"></i> Role</label>
                  <select class="form-select" v-model="user_data_current.role">
                    <option value="User">User</option>
                    <option value="Operator">Operator</option>
                    <option value="Editor">Editor</option>
                    <option value="Admin">Admin</option>

                    <option value="Owner" v-if="[ 'Owner'].includes(userInfo.role)">Owner</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label"><i class="bi bi-bookmark"></i> Note</label>
                  <textarea class="form-control" rows="4" placeholder="Add a note..." v-model="user_data_current.note"></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><font-awesome-icon :icon="['fas', 'xmark']" /> Close</button>
            <button  data-bs-dismiss="modal" aria-label="Close" type="button" class="btn border-0 text-dark" @click="editUser(user_data_current)" style="background-color:rgb(193, 231, 254);font-weight: bold;"> <font-awesome-icon :icon="['fas', 'pen']" /> Edit User</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        user_data_current:{},
        users: [],
        userInfo: {
          username: "",
          role: ""
        },
        loading: false,
        q: "",
        page: 1,
        size: 10,
        total: 0,
      };
    },
    computed: {
      disableNext() {
        return this.page * this.size >= this.total;
      },
    },
    mounted() {
      this.fetchUsers()
    },
    methods: {
      async fetchUsers() {
        try {
          this.loading = true;
          const params = new URLSearchParams({
          ...(this.q ? { q: this.q } : {}),
          page: String(this.page),
          size: String(this.size),
        });
          var accessToken = localStorage.getItem("accessToken");
          const response = await fetch(`${process.env.VUE_APP_API_URL}/api/users/all?`+ params.toString(), {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${accessToken}`
            }
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          this.users = data.data;
          this.total = data?.meta?.total ?? this.users.length;
        } catch (error) {
          this.list_plan = [];
          
          console.error('Error fetching dashboard data:', error);
        }finally {
          this.loading = false;
        }

      },

      async deleteUser(id) {
        try {
          var accessToken = localStorage.getItem("accessToken");
          const response = await fetch(`${process.env.VUE_APP_API_URL}/api/users?userid=`+id, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${accessToken}`
            }
          });
          this.fetchUsers()
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

        } catch (error) {
          console.error('Error fetching dashboard data:', error);
        }

      },

      async editUser(userData){

        try {
          var accessToken = localStorage.getItem("accessToken");
          const response = await fetch(`${process.env.VUE_APP_API_URL}/api/users`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${accessToken}`
            },
            body: JSON.stringify({
              "id":userData.id,
              "username": userData.username,
              "email": userData.email,
              "password": userData.password,
              "confirmPassword": userData.password,
              "firstName": userData.firstName,
              "lastName": userData.lastName,
              "role": userData.role 
            })
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();
          this.$router.push('/user/listuser');

          console.log('Dashboard page created:', result);
        } catch (error) {
          console.error('Error creating dashboard page:', error);
        }
      },
      reload() {
        this.page = 1;
        this.fetchUsers()
      },
      nextPage() {
        if (!this.disableNext) {
          this.page++;
          this.fetchUsers()
        }
      },
      prevPage() {
        if (this.page > 1) {
          this.page--;
          this.fetchUsers()
        }
      },
    },
    created() {
      
      this.userInfo.username = localStorage.getItem("username");
      this.userInfo.role = localStorage.getItem("role");
    }
  };
</script>

